import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

import { Glampoints } from "components/icons/Glampoints";
import { Beauty } from "components/icons/Beauty";
import { GlamClub } from "components/icons/GlamClub";
import { Influencer } from "components/icons/Influencer";
import { Glambox } from "components/icons/Glambox";
import { Subscription } from "components/icons/Subscription";
import { IsOrWasSubscriber } from "core/utils/SubscriberUtils";

class Beneficios extends Component {
  componentDidMount() {
    const {
      person,
      history,
      subscribers
    } = this.props;

    // Assinantes, Ex-Assinantes e Glampartners não precisam
    if (
      person.person 
        && IsOrWasSubscriber(person.person.personStatus) 
        && Array.isArray(subscribers) 
        && subscribers.length > 0
    ) {
      history.push("/");
    }
  }

  render () {
    return (
      <div className={"p-2 p-lg-5"}>
        <Helmet>
          <title>Minha Glambox : Benefícios</title>
        </Helmet>
        
        <h1>Benefícios</h1>
        <div className={"level-2 d-flex beneficios_page"}>
          <div className={"p-3 p-xl-5 item"}>
            <GlamClub fill={"#00e381"} />
            <div>
              <h5>Experimentação</h5>
              <p><strong>Presenteie-se</strong> todos os meses com produtos de beleza e bem-estar e conheça marcas novas.</p>
            </div>
          </div>
          <div className={"p-3 p-xl-5 item"}>
            <Beauty fill={"#00e381"} />
            <div>
              <h5> Produtos customizados </h5>
              <p>A montagem da sua caixinha é feita de acordo com o seu <strong>perfil de beleza.</strong></p>
            </div>
          </div>
          <div className={"p-3 p-xl-5 item"}>
            <Subscription fill={"#00e381"} />
            <div>
              <h5>Custo x Benefício (3x valor pago)</h5>
              <p>Receba itens que valem <strong>até 3 vezes</strong> o valor da sua assinatura.</p>
            </div>
          </div>
          <div className={"p-3 p-xl-5 item"}>
            <Glambox fill={"#00e381"} />
            <div>
              <h5>Superbox</h5>
              <p>Edições especiais, super exclusivas e fora da assinatura. <strong>Glamgirls tem prioridade</strong> e podem adquiri-las através do site.</p>
            </div>
          </div>
          <div className={"p-3 p-xl-5 item"}>
            <Influencer fill={"#00e381"} />
            <div>
              <h5>Comunidade</h5>
              <p>Faça parte de um grupo fechado só para Glamgirls e acesse conteúdo exclusivo como <strong>cursos onlines</strong> e <strong>lives.</strong></p>
            </div>
          </div>
          <div className={"p-3 p-xl-5 item"}>
            <Glampoints />
            <div>
              <h5>Glamclub </h5>
              <p>Acumule glampoints e troque por mais produtos no nosso clube de fidelidade.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  person: state.person.data,
  editions: state.editions,
  subscribers: state.subscribers.data
});

Beneficios = connect(mapStateToProps)(Beneficios);

export { Beneficios };